import React, { Component, Fragment } from "react";
import { Menu, Input, Icon, Dropdown, Image } from "semantic-ui-react";
import logo from "../../static/media/logo_white.103c2fa2.png";

class SiteHeader extends Component {
  constructor() {
    super();
    this.state = { activeItem: "MyView" };
  }
  componentDidMount() { }
  componentWillReceiveProps(nextState, nextProps) {
    // console.log("Props--", nextState, nextProps);
  }
  handleItemClick = (e, { name }) => this.setState({ activeItem: name });

  createNewUser() {
    console.log(this.props);
  }
  render() {
    const { activeItem } = this.state;

    return (
      <Fragment>
        <Menu inverted>
          <Menu.Item as="a">
            <Image size="tiny" src={logo} />
          </Menu.Item>
          <Menu.Item
            as="a"
            name=" MyView"
            active={activeItem === " MyView"}
            onClick={this.handleItemClick}
          >
            My View
          </Menu.Item>
          <Menu.Item
            as="a"
            name=" Reports"
            active={activeItem === " Reports"}
            onClick={this.handleItemClick}
          >
            Reports
          </Menu.Item>
          <Menu.Item
            as="a"
            name=" Scheduler"
            active={activeItem === " Scheduler"}
            onClick={this.handleItemClick}
          >
            Scheduler
          </Menu.Item>

          <Menu.Menu position="right">
            <Menu.Item>
              <Input size="small" placeholder="Search here..." />
            </Menu.Item>
            <Menu.Item as="a">
              <Icon className="xcm-icon-advanced-search" size="large" />
            </Menu.Item>
            <Menu.Item as="div" color="orange" className="firmName truncate">
              {" "}
              XCM Solutions / Xpitax LLC Testing
            </Menu.Item>
            <Menu.Item as="a">
              <Icon className="xcm-icon-settings-fill" size="large" />
            </Menu.Item>
            <Dropdown item simple text="Philip Nolan">
              <Dropdown.Menu>
                <Dropdown.Item>Profile</Dropdown.Item>
                <Dropdown.Item>My Calendar</Dropdown.Item>
                <Dropdown.Item>Log Off</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Menu>
        </Menu>

        {/* <Menu tabular size="small">
          <Menu.Item
            name="User Group Rights"
            active={activeItem === "User Group Rights"}
            onClick={this.handleItemClick}
          />

          <Menu.Menu position="right">
            <Menu.Item as="a">Help</Menu.Item>
            <Menu.Item as="a">Video</Menu.Item>

            <Menu.Item as="a">User Guide</Menu.Item>
          </Menu.Menu>
        </Menu> */}
      </Fragment>
    );
  }
}

export default SiteHeader;
